<template>
  <section class="categories">
    <div class="categories-header">
      <aside class="categories-title">
        <h2>Categorias</h2>
      </aside>
      <aside class="categories-button">
        <button @click="redirect('productos')">Ver mas</button>
      </aside>
    </div>
    <swiper
      ref="{swiperRef}"
      :breakpoints="{
        '640': {
          slidesPerView: 2,
          spaceBetween: 15,
        },
        '768': {
          slidesPerView: 4,
          spaceBetween: 25,
        },
        '1024': {
          slidesPerView: 5,
          spaceBetween: 30,
        },
      }"
      :slidesPerView="4"
      :centeredSlides="false"
      :spaceBetween="30"
      :navigation="true"
      :modules="modules"
      class="mySwiper list-content"
    >
      <swiper-slide v-for="category in categories" :key="category.id">
        <article class="category">
          <img
            :src="category.img"
            :alt="category.description"
            v-if="category.img"
          />
          <img
            src="https://res.cloudinary.com/dyikvzcke/image/upload/v1752445725/Image-not-found_dqbmcg.png"
            alt=""
            v-else
          />
          <div class="category-info">
            <h5>{{ category.name }}</h5>
            <router-link :to="`/productos?categories=${category.id}`">Ver categoria</router-link>
          </div>
        </article>
      </swiper-slide>
    </swiper>
  </section>
</template>

<script setup>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "../styles/CategoriesHome.style.scss";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper/modules";
import { ref } from "vue";
import categories from "@/data/categories.json";
import { useRouter } from "vue-router";

const modules = ref([Pagination, Navigation]);
const route = useRouter();

function redirect(pathName) {
  route.push({ name: pathName });
}
</script>

<style lang="scss" scoped>
.categories {
  display: flex;
  flex-direction: column;
  gap: 45px;
  padding-inline: 300px;
  margin-top: 120px;
  overflow-x: hidden;
  h2 {
    color: #071725;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  .categories-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .categories-title {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }
    .categories-button {
      button {
        padding: 10px 20px;
        border: 1px solid $tint4;
        background: none;
        color: $tint2;
        border-radius: 5px;
        cursor: pointer;
        transition: background-color 0.3s ease;

        &:hover {
          background-color: $tint4;
        }
      }
    }
  }
  .list-content {
    .category {
      width: 100%;
      display: flex;
      padding-block: 40px;
      flex-direction: column;
      align-items: center;
      gap: 40px;
      border-radius: 10px;
      background: #fff;
      overflow: hidden;
      background-color: $tint1;
    }
    .category::before {
      content: ''; /* Es obligatorio para que el pseudo-elemento se muestre */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../../assets/images/bg-lumi.png");
    background-size: cover; /* Para que la imagen cubra todo el pseudo-elemento */
    background-position: center; /* Centra la imagen */
    opacity: 0.3; /* Ajusta este valor para controlar la opacidad (0 a 1) */
    z-index: 1; /* Coloca el pseudo-elemento detrás del contenido */
    }
    .category img {
      height: 200px;
      object-fit: contain;
      z-index: 2;
    }
    .category .category-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 12px;
      z-index: 2;
    }
    .category h5 {
      color: $whited;
      font-size: 24px;
      font-weight: 500;
      line-height: normal;
    }
    .category a {
      background-color: $tint1;
      display: flex;
      padding: 10px 20px;
      text-decoration: none;
      border-radius: 5px;
      color: $whited;
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
    }
  }
}

@media (max-width: 1600px) {
  .categories {
    padding-inline: 100px;
    h2 {
        font-size: 32px
    }
  }
}
@media (max-width: 1080px) {
  .categories {
    padding-inline: 80px;
    h2 {
        font-size: 24px
    }
    .categories-header {
      display: flex;
      align-items: start;
      flex-direction: column;
      gap: 20px;
    }
    .list-content {
      .category {
        img {
          width: 300px;
        }
        h5 {
          font-size: 20px;
        }
      }
    }
  }
}
@media (max-width: 580px) {
  .categories {
    padding-inline: 20px;
    .head-content {
      button {
        padding: 10px 15px;
        .text-more {
          display: none;
        }
      }
    }
    .list-content {
      .category {
        img {
          width: 250px;
        }
        h3 {
          font-size: 16px;
        }
        a {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
